import { connect } from 'react-redux';

import { fetchOutreachPage } from 'client/ducks/outreach/actions';
import { getEvents, getProjects, getDatasets, isLoading } from 'client/ducks/outreach/selectors';
import { State } from 'client/store';

import OutreachPage, { DispatchProps, StateProps } from './outreach';

function mapStateToProps(state: State): StateProps {
    return {
        events: getEvents(state),
        projects: getProjects(state),
        datasets: getDatasets(state),
        isLoading: isLoading(state)
    };
}

const mapDispatchToProps = {
    fetchOutreachPage
} as any;

export default connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(OutreachPage) as any;
